import styled from 'styled-components/macro'

import * as React from 'react'

import { queries } from '../app/Responsive'
import { Spacing } from '../styling'
import { createContext } from '../tools/createContext'

type TProps = Children & {
  className?: string
  gridTemplateColumns?: string
}

type TStyledProps = {
  gridTemplateColumns: string
}

const ROW_GAP = Spacing.formElementVerticalGap
const DEFAULT_GRID_TEMPLATE_COLUMNS = `0.1fr [desc] auto [content] 1fr`

const StyledFormGrid = styled.div<TStyledProps>`
  display: grid;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
  grid-template-areas: '. desc content';
  grid-auto-flow: row dense;
  grid-row-gap: ${ROW_GAP};

  @media ${queries.mobile} {
    grid-template-columns: 1fr;
    grid-template-areas: 'content';
  }
`

const StyledGridContent = styled.div<TProps>`
  grid-column: content;
  margin-left: 0.5rem;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  row-gap: ${ROW_GAP};
  column-gap: 0.5rem;
`

// any type/value would do, we just need to know if we're in a grid or not
const [Provider, , useGridContextUnsafe] = createContext<boolean>(`FormGrid`)

export const FormGrid: React.FC<TProps> = ({
  children,
  className,
  gridTemplateColumns = DEFAULT_GRID_TEMPLATE_COLUMNS,
}) => {
  return (
    <StyledFormGrid
      className={className}
      gridTemplateColumns={gridTemplateColumns}
    >
      <Provider value={true}>{children}</Provider>
    </StyledFormGrid>
  )
}

export const useFormGridCheck = () => {
  // use unsafe version because we do want to be able to use this outside of the provider as well
  return useGridContextUnsafe() !== undefined
}

/**
 * Styled grid container for content inside the form grid
 *
 * It has variable columns that respond to the screen size
 */
export const FormGridContentBox: React.FC<TProps> = ({ children }) => {
  return (
    <StyledGridContent>
      <Provider value={false}>{children}</Provider>
    </StyledGridContent>
  )
}
